<template>
    <div class="mt6 ml20 mr20">
        <el-row :gutter="20" v-for="(page,index) in moduleTabs" :key="page.name+index+'Tabs'">
            <el-col :span="5">
                <div>
                    <el-checkbox v-model="page.checked" @change="handleChangePage(page,$event)" :disabled="isView||page.disabled">{{page.display_name}}</el-checkbox>
                    <span class="ml20 font12px pointer check-btn" v-if="!isView" @click="handleCheckPage(page)">全选</span>
                </div>
                <div>
                    <template v-if="page.checked">
                        <el-button type="text" v-if="page.fields.length>0" @click="showFieldsModal(page,module)">{{isView?'查看':'设置'}}字段权限</el-button>
                        <el-button type="text" v-if="page.dimension.length>0" @click="showDimensionsModal(page)">{{isView?'查看':'设置'}}维度权限</el-button>
                        <el-button type="text" v-if="page.special_func.length>0" @click="showConfigOptionalRoleModal(page)">{{isView?'查看':'配置'}}可选角色</el-button>
                        <el-button type="text" v-if="page.statistical_period&&page.statistical_period.length>0" @click="showStatisticalPeriodModal(page)">统计周期权限</el-button>
                    </template>
                </div>
            </el-col>
            <el-col :span="15">
                <template v-if="page.func&&page.func.length>0">
                    <el-checkbox-group :value="page.checkedFunc" @change="handleChangeFunc(page,$event)" class="mb6" :disabled="isView||page.disabled">
                        <el-checkbox v-for="item in page.func" class="fun-checkbox" :label="item.id" :disabled="item.disabled" :key="item.id" @change="handleChangeFuncItem(page,item,$event)">
                            {{item.display_name}}
                            <el-tooltip v-if="getItemTitle(item).length>0" class="item" effect="dark" :content="getItemTitle(item)" placement="top">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </el-checkbox>
                    </el-checkbox-group>
                </template>
                <div v-else>
                    <p class="text-color-gray">暂无数据</p>
                </div>
            </el-col>
            <el-col :span="4">
                <!--信息管理-标签维护页面:禁用数据权限设置-->
                <div class="mt6 mb6" v-if="page.name=='tag_management_page'||page.name=='project_management_page'">
                    <el-radio-group disabled :title="page.name=='tag_management_page'?'此页面显示所有标签':'此页面显示所有项目'">
                        <el-radio label="2" disabled>按照自身部门数据权限</el-radio>
                        <el-radio label="1" disabled>全部账户&成员数据</el-radio>
                    </el-radio-group>
                </div>
                <!--首页-运营负责人:不展示数据权限设置-->
                <div class="mt6 mb6" v-else>
                    <el-radio-group v-model="page.role_action" @change="changeRoleAction(page,$event)" :disabled="isView||page.disabled||isDashboardPage(page)">
                        <el-radio label="2" :title="isDashboardPage(page)?'该页面根据登陆成员的部门数据权限查询对应成员的数据，若需查看全部账户&成员数据可修改部门数据权限达到此目的！':''" @dblclick.native="resetRoleAction(page)">按照自身部门数据权限</el-radio>
                        <el-radio label="1" :title="isDashboardPage(page)?'该页面根据登陆成员的部门数据权限查询对应成员的数据，若需查看全部账户&成员数据可修改部门数据权限达到此目的！':''" @dblclick.native="resetRoleAction(page)" :disabled="page.role_action_config==2||module.name=='organization_management'">全部账户&成员数据</el-radio>
                    </el-radio-group>
                </div>
            </el-col>
        </el-row>

        <FieldsModal
            ref="fieldsModal"
            :isView="isView"
            :fields="actionFields"
            :actionType="actionType"
            :page="actionPage"
            @save-fields="handleSaveFields"

        ></FieldsModal>
        <ConfigOptionalRoleModal
            ref="configOptionalRoleModal"
            :isView="isView"
            :page="actionPage"
            @save-roles="handleSaveRoles"
        />
        <TagFieldsModal
            ref="tagFieldsModal"
            :isView="isView"
            :fields="actionFields"
            :page="actionPage"
            :tag-editable="tagEditable"
            @save-fields="handleSaveTagFields"/>

        <StatisticalPeriodModal
            ref="statisticalPeriodModal"
            :isView="isView"
            :page="actionPage"
            :fields="actionFields"
            @save="handleSavePeriod"
        />
    </div>

</template>

<script>
    import FieldsModal from '../modal/roleFields2.vue';
    import ConfigOptionalRoleModal from '../modal/configOptionalRole';
    import TagFieldsModal from '../modal/tagFieldsConfig';
    import utils from '@/libs/utils.js';
    import StatisticalPeriodModal from '../modal/statisticalPeriodModal';

    export default {
        name: "CollapseContent",
        components:{
            FieldsModal,
            ConfigOptionalRoleModal,
            TagFieldsModal,
            StatisticalPeriodModal,
        },
        props: {
            module:{
                type: Object,
                default: function () {
                    return {}
                }
            },
            isView:{
                type: Boolean,
                required:false,
                default:false,
            },
            allowActions:{
                required:true,
                type:Object,
            },
            page:{
                type: String,
                required:false,
                default:'',
            },
            tagEditable:{
                required:true,
                type:Object,
            },
            specialConfig:[Object,String],
        },
        data(){
            return {
                // moduleTabs:[],
                customFields:[],
                customDimensions:[],
                actionPage:{},
                actionFields:[],
                actionType:'',
            }
        },
        computed:{
            moduleTabs(){
                let pages  = [];
                let formPlats = this.allowActions.plat_ids||[];
                if(this.module.name=='data_query_analysis'){
                    let plats = formPlats.map(item=>'data_'+item).concat('data_all');
                    pages = this.module.children.filter(item=>plats.includes(item.name));
                }else if(this.module.name=='app_kpi_manage'){
                    let plats = formPlats.map(item=>'app_kpi_'+item);
                    pages = this.module.children.filter(item=>plats.includes(item.name));
                }else{
                    pages = this.module.children||[];
                }
                return pages.map(item=>{
                    this.$set(item,'checkedFunc',item.func.filter(item=>item.checked).map(item=>item.id));
                    // item.checkedFunc = item.func.filter(item=>item.checked).map(item=>item.id);
                    item.customFields =  item.fields;
                    return item;
                });
            },
            isTagManagePage(){
                return this.module.name=='tag_management';
            }
        },
        methods:{
            showFieldsModal(page,module){
                let moduleName = (module||{}).name||'';
                this.actionPage = page;
                console.log('showFieldsModal',page);
                /* 基础信息管理：集团、客户、账户、计划、产品、项目等tab页 */
                let tagSubPage = [
                    'plat_management_page',
                    'bloc_management_page',
                    'company_management_page',
                    'account_management_page',
                    'plan_management_page',
                    'app_management_page',
                    'project_management_page',
                ];

                let marketManageAppleTabs = [
                    'apple_org',
                    'apple_campaign',
                    'apple_adgroup',
                    'apple_keyword',
                    'apple_search_term',
                    'apple_negative_keyword',
                ];

                if(this.isTagManagePage&&tagSubPage.includes(page.name)){
                    this.actionFields = page.fields;
                    this.actionType = 'fields';
                    this.$refs.tagFieldsModal.showModal();
                }else if(page.name=='daily_task_page'){
                    /*自动化日报：日报工具有特殊判断*/
                    this.actionFields = this.getPlatDailyTaskFields(page);
                    this.actionType = 'fields';
                    this.$refs.fieldsModal.showModal();
                }else if(moduleName=='apple'&&marketManageAppleTabs.includes(page.name)){
                    /* 推广管理：apple渠道下各tab页 有特殊判断 */
                    this.actionFields = this.getPlatFields(page,'9','fields');
                    this.actionType = 'fields';
                    this.$refs.fieldsModal.showModal();
                }else{
                    let matchItem = (page.name||'').match(/\d+/)||[];
                    let pagePlatId = matchItem.length>0?matchItem[0]:'';
                    this.actionFields = pagePlatId?this.getPlatFields(page,pagePlatId,'fields'):page.fields;
                    this.actionType = 'fields';
                    this.$refs.fieldsModal.showModal();
                }
            },
            showDimensionsModal(page){
                this.actionPage = page;
                console.log('showDimensionModal',page);

                if(page.name=='daily_task_page'){
                    /*自动化日报：日报工具有特殊判断*/
                    this.actionFields = this.getPlatDailyTaskDimensions(page,'dimension');
                    this.actionType = 'dimensions';
                    this.$refs.fieldsModal.showModal();

                }else{
                    let pageItem = (page.name||'').match(/\d+/)||[];
                    let pagePlatId = pageItem[0]||'';
                    this.actionFields = pagePlatId?this.getPlatFields(page,pagePlatId,'dimension'):page.dimension;
                    this.actionType = 'dimensions';
                    this.$refs.fieldsModal.showModal();
                }
            },
            getPlatFields(page,platId,type){
                console.log('getPlatFields',page,platId,type,this.allowActions);
                // let platFields = page[type][platId]
                let allowPlatData = type==='dimension'?this.allowActions.dimension_type[platId]:this.allowActions.data_type[platId];
                console.log('allowPlatData',allowPlatData);


                return page[type].filter(item=>allowPlatData.includes(item.mid));
                // return page[type];
            },
            getPlatDailyTaskDimensions(page){
                console.log('getPlatDailyTaskDimensions',page);
                page = utils.deepClone(page);
                let allowPlats = this.allowActions.plat_ids||[];
                let fieldsArr = page.dimension||[];
                return fieldsArr.filter(item=>{
                    let platItem = (item.name||'').match(/\d+/)||[];
                    let pagePlatId = platItem[0]||'';
                    return allowPlats.includes(pagePlatId);
                }).map(item=>{
                    let platItem = (item.name||'').match(/\d+/)||[];
                    let pagePlatId = platItem[0]||'';
                    let allowDimensionType = this.allowActions.dimension_type||{};
                    let platDimensionType = allowDimensionType[pagePlatId]||[];

                    item.children = (item.children||[]).filter(inner=>{
                        return platDimensionType.includes(inner.mid);
                    });
                    return item;
                });
            },
            getPlatDailyTaskFields(page){
                console.log('getPlatDailyTaskFields',page);
                page = utils.deepClone(page);
                let allowPlats = this.allowActions.plat_ids||[];
                let fieldsArr = page.fields||[];
                return fieldsArr.filter(item=>{
                    let platItem = (item.name||'').match(/\d+/)||[];
                    let pagePlatId = platItem[0]||'';
                    return allowPlats.includes(pagePlatId);
                }).map(item=>{
                    let platItem = (item.name||'').match(/\d+/)||[];
                    let pagePlatId = platItem[0]||'';
                    let allowDataType = this.allowActions.data_type||{};
                    let platDataType = allowDataType[pagePlatId]||[];

                    item.children = (item.children||[]).filter(inner=>{
                        return platDataType.includes(inner.mid);
                    });
                    return item;
                });

            },
            showConfigOptionalRoleModal(page){
                this.actionPage = page;
                this.$refs.configOptionalRoleModal.showModal();
            },
            showStatisticalPeriodModal(page){
                console.log('showStatisticalPeriodModal',page);
                this.actionFields = page.statistical_period||[];
                this.actionPage = page;
                let periodConfig = this.specialConfig.statistical_period||{};

                this.$refs.statisticalPeriodModal.showModal(periodConfig);
            },
            changeRoleAction(page,val){
                console.log('changeRoleAction',page,val);

                let pageItem = this.moduleTabs.find(item=>item.id==page.id);

                // let val = oldVal=='1'?'2':'1';
                if(val=='1'){
                    this.$messageBox.confirm('确认修改页面数据权限为【全部账户&成员数据】吗？', '警告', {
                        closeOnPressEscape:false,
                        confirmButtonText: '确认修改',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        console.log('确定');
                        pageItem.role_action = '1';
                        this.$emit('save-role-action',val,page);
                    }).catch(() => {
                        console.log('取消');
                        // this.$nextTick(()=>{
                        //     console.log('取消2');
                        //     page.role_action = '2';
                        // });
                        // this.$set(page,'role_action','2');
                        pageItem.role_action = '2';
                        this.$emit('save-role-action','2',page);
                    });
                }else{
                    pageItem.role_action = '2';
                    this.$emit('save-role-action','2',page);
                }
                this.$forceUpdate();
            },
            handleChangeFunc(page,val){
                this.$emit('save-func',val,page);
            },
            handleChangeFuncItem(page,item,val){
                console.log('handleChangeFuncItem',page,item,val);
                if(val){
                    page.checkedFunc.push(item.id);
                    if(item.auto_check){
                        let checkArr = item.auto_check.split(',');
                        page.checkedFunc.push(...checkArr);
                    }
                }else {
                    /* 待完善：如果字段有前后联动，需要分别处理？ */
                    let index = page.checkedFunc.findIndex(id=>item.id==id);
                    if(index!=-1){
                        page.checkedFunc.splice(index,1);
                    }
                }
            },
            handleSaveFields(page,val,type){
                this.$emit('save-fields',val,page,type);
            },
            handleSaveTagFields(page,viewChecked,editChecked){
                console.log('handleSaveTagFields',page,viewChecked,editChecked);
                this.$emit('save-tag-fields',page,viewChecked,editChecked);
            },
            handleSavePeriod(page,data){
                console.log('handleSavePeriod',page,data);
                this.$emit('save-period',page,data);
            },
            handleSaveDimensions(page,val){
                console.log('save-dimensions',val,page);
                this.$emit('save-dimensions',val,page);
            },
            handleSaveRoles(page,val){
                this.$emit('save-roles',val,page);
            },
            handleCheckPage(page){
                if(page.disabled) return;
                this.$emit('check-page',page);
            },
            handleChangePage(page,val){
                console.log('change-page',val,page);
                this.$emit('change-page',val,page);
            },
            isDashboardPage(page){
                let pageName = (page||{}).name||'';
                return pageName=='yy_director'||pageName=='xs_director'||pageName=='kf_director';
            },
            resetRoleAction(page){
                console.log('resetRoleAction',page);
                /* 仅批量增加权限页面可以取消 */
                if(this.page!=='batch') return false;
                if(page.disabled) return false;
                page.role_action = null;
                this.$emit('save-role-action','',page);
            },
            getItemTitle(item){
                let configStr = item.config||"{}";
                let config = JSON.parse(configStr)||{};
                return config.title||'';
            },
        }
    }
</script>

<style lang="scss" scoped>
    .check-btn{
        color: #808695;
        &:hover{
            color: #17233d;
        }
    }
    .fun-checkbox{
        min-width: 120px;
    }
</style>
